import React, { useEffect } from 'react'

import { useDispatch } from 'react-redux'

import styles from '../../styles.module.scss'

import { viewEvent } from '../../../utils'
import { action, serviceMap } from '../../../constants'
import { setServiceData } from '../../../../../../redux/billing/billing.action'

const PersonalStatusHasExpired = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    viewEvent(action.hasExpired, serviceMap.personalStatus)

    return () => {
      // set the data: {} after checking the service event,
      // so that there is no function getServiceData call, it should be called once, when initializing the application
      dispatch(setServiceData({ service: serviceMap.personalStatus, data: {} }))
    }

    // eslint-disable-next-line
  }, [])

  return (
    <div className={styles.description}>
      <p className={styles.description_item}>Attention! Personal Status subscription has expired.</p>
      <p>If you want your personal status to continue to be visible to crew managers, please renew your subscription</p>
    </div>
  )
}

export default PersonalStatusHasExpired
